/*  ==========================================================================
		PHP Variables
		========================================================================== */

// If you need to access variables such as template url, or AJAX url within this file you can use the variable php_variables.template_url or php_variables.ajax_url
// which has been passed in via enqueue-scripts.php

/*  ==========================================================================
		Grid variables - needed for gridcarousel__init
		========================================================================== */

// NOTE: If your updating this make sure to also update the SASS Variables in _variables.scss
const gridSizes = {
  sm: "550",
  md: "700",
  lg: "1000",
  xl: "1200",
  ws: "1400",
  xw: "1600",
  xxw: "1800",
  xxxw: "2000"
};

/*  ==========================================================================
      DOM element variables 
      ========================================================================== */

const body = document.querySelector("body");

/*  ==========================================================================
		Device Detection - Check if is mobile or ipad
		========================================================================== */

let isMobile = false; // initiate as false
const isTouchDevice = !!("ontouchstart" in window);

if (/Android|webOS|iPhone|iPod|BlackBerry|IEMobile|Opera Mini/i.test(window.navigator.userAgent)) {
  isMobile = true;
}

/*  ==========================================================================
		GENERAL - add linklines to links
		========================================================================== */

const linksInit = function () {
  const links = document.querySelectorAll("a:not(.noline):not(.line--added)");
  links.forEach(function (el) {
    if (el.closest(".noline")) {
      return;
    }

    const icon = el.querySelector(".fa, .fas, .far, .fal, .fab");

    if (el.querySelector("img") < 1) {
      const linkHTML = "<span class='linkline'>" + el.textContent + "</span>";
      el.innerHTML = linkHTML;
      el.classList.add("line--added");
      if (icon) {
        const iconHTML = icon;
        if (icon.classList.contains("fa--left")) {
          el.querySelector(".linkline").before(icon);
        } else {
          el.querySelector(".linkline").after(icon);
        }
      }
    }
  });
  //return true;
}; // linksInit();
linksInit();

/*  ==========================================================================
    GENERAL - sharinglinks
    ========================================================================== */

const sharingLinksInit = function () {
  const links = document.querySelector(".shareiconslist");

  if (!links) {
    return;
  }

  links.addEventListener("click", function (e) {
    e.preventDefault();
    const clicked = e.target.closest(".sharelink--popup");

    if (!clicked) {
      return;
    }

    const shareURL = clicked.getAttribute("href");
    window.open(shareURL, "share-dialog", "width=550,height=436");
  });
}; // sharingLinksInit();
sharingLinksInit();

/*  ==========================================================================
    GENERAL - accordion
    ========================================================================== */
const accordionQuestions = document.querySelectorAll(".accordion__question");

const accordionInit = function (accordionItems) {
  if (!accordionItems) {
    return;
  }

  accordionItems.forEach(item =>
    item.addEventListener("click", function () {
      item.closest(".accordion__item").classList.toggle("accordion__item--open");
      this.classList.toggle("active");
      var panel = this.nextElementSibling;
      if (panel.style.maxHeight) {
        panel.style.maxHeight = null;
        setTimeout(function () {
          Waypoint.refreshAll();
        }, 500);
      } else {
        panel.style.maxHeight = panel.scrollHeight + "px";
        setTimeout(function () {
          Waypoint.refreshAll();
        }, 500);
      }
    })
  );
}; // accordionInit();
accordionInit(accordionQuestions);

/*  ==========================================================================
    GENERAL - LazyLoad - Enable Lazy load for images
    ========================================================================== */

// Lazy load images (or everything with .lazy)
const lazyLoadInstance = new LazyLoad();

/*  ==========================================================================
    GENERAL - Initiate plyr (custom video controls)

    This is automatically disabled on builds, to enable uncomment the JS here
    and then go to functions / enqueue-scripts and enqueue-styles to uncomment and enable the css and JS 

    ========================================================================== */

// const plyrsInit = function () {
//   const plyrs = document.querySelectorAll(".mediavideo:not(.mediavideo--autoplay)");

//   if (!plyrs) {
//     return;
//   }

//   plyrs.forEach(function (el) {
//     let plyr = el.querySelector(".mediavideo__video");
//     new Plyr(plyr, {
//       controls: ["play", "progress", "mute", "current-time"],
//       hideControls: true,
//       invertTime: false,
//       tooltips: { controls: false, seek: false }
//     });
//   });
// }; // plyrsInit();

// plyrsInit();

/*  ==========================================================================
  GENERAL - Share Icons
========================================================================== */
const socialLinksInit = function () {
  const socialLinks = document.querySelectorAll(".sociallink");

  if (!socialLinks) {
    return;
  }

  socialLinks.forEach(socialLink =>
    socialLink.addEventListener("click", function (e) {
      e.preventDefault();
      const shareURL = this.getAttribute("href");
      var w = 550;
      var h = 550;
      var left = Number(screen.width / 2 - w / 2);
      var tops = Number(screen.height / 2 - h / 2);
      window.open(
        shareURL,
        "share-dialog",
        "resizable=no, width=" + w + ", height=" + h + ", top=" + tops + ", left=" + left + ""
      );
    })
  );
}; // socialLinksInit();
socialLinksInit();

/*  ==========================================================================
    GENERAL - Accordion & Media
  ========================================================================== */

const setActiveItem = function (accordionMediaItems, item) {
  accordionMediaItems.forEach(el => {
    el.classList.remove("active");
    el.querySelector(".item__inner").style.height = "0px";
  });
  item.classList.add("active");
  let innerHeight = item.querySelector(".item__leader").offsetHeight;
  item.querySelector(".item__inner").style.height = innerHeight + "px";
};

const accordionMediaInit = function () {
  const accordionMedia = document.querySelectorAll(".module--accordion-media");

  if (!accordionMedia) {
    return;
  }

  accordionMedia.forEach(module => {
    const accordionMediaItems = module.querySelectorAll(".accordion-media__item");

    if (!accordionMediaItems) {
      return;
    }

    accordionMediaItems.forEach(item => {
      item.addEventListener("click", function () {
        setActiveItem(accordionMediaItems, this);
      });
    });

    // set first item as active on load
    setActiveItem(accordionMediaItems, accordionMediaItems[0]);

    window.addEventListener(
      "resize",
      function (event) {
        setActiveItem(accordionMediaItems, module.querySelector(".accordion-media__item.active"));
      },
      true
    );
  });
};
accordionMediaInit();

/*  ==========================================================================
    GENERAL - Table content module
    ========================================================================== */
$(function () {
  // $('.tab-content:first-child').show();
  $(".table-content__list__link").bind("click", function (e) {
    var $this = $(this);
    // var $tabs = $this.parent().parent().next();
    var $target = $($this.data("target")); // get the target from data attribute
    $this.siblings().removeClass("active");
    $target.siblings().css("display", "none");
    $this.addClass("active");
    $target.fadeIn("fast");
    Waypoint.refreshAll();
  });
  $(".table-content__list__link:first-child").trigger("click");
  $(".col > .table-content__mobile__item:first-child > .table-content__mobile-link").trigger("click");
});

var tableContentMobileLinks = document.getElementsByClassName("table-content__mobile-link");
var i;

for (i = 0; i < tableContentMobileLinks.length; i++) {
  /* jshint ignore:start */
  tableContentMobileLinks[i].addEventListener("click", function () {
    this.classList.toggle("active");
    setTimeout(function () {
      Waypoint.refreshAll();
    }, 500);
    var panel = this.nextElementSibling;
    if (panel.style.maxHeight) {
      panel.style.maxHeight = null;
    } else {
      panel.style.maxHeight = panel.scrollHeight + "px";
    }
  });
  /* jshint ignore:end */
}

$(".table-content__mobile-content > div.row.accordion > div > .accordion__item").on("click", function () {
  var panel = $(this).closest(".table-content__mobile-content");
  setTimeout(function () {
    $(panel).css("max-height", panel.prop("scrollHeight"));
  }, 300);
});

/*  ==========================================================================
  GENERAL - Pageheader 
========================================================================== */
const pageHeaderVideoInit = function () {
  const pageHeaderVideo = document.querySelector("#pageheader__video__inline");

  if (!pageHeaderVideo) {
    return;
  }

  let hasStarted = false;

  const cleanupInteractionListeners = function () {
    document.removeEventListener("click", startFromUserInteraction);
    document.removeEventListener("touchstart", startFromUserInteraction);
    document.removeEventListener("keydown", startFromUserInteraction);
  };

  const attemptAutoplay = function () {
    if (hasStarted) {
      return;
    }

    pageHeaderVideo.muted = true;
    pageHeaderVideo.defaultMuted = true;
    pageHeaderVideo.playsInline = true;
    pageHeaderVideo.autoplay = true;
    pageHeaderVideo.setAttribute("muted", "muted");
    pageHeaderVideo.setAttribute("playsinline", "playsinline");
    pageHeaderVideo.setAttribute("autoplay", "autoplay");

    const playPromise = pageHeaderVideo.play();

    if (playPromise && typeof playPromise.then === "function") {
      playPromise
        .then(function () {
          hasStarted = true;
          cleanupInteractionListeners();
        })
        .catch(function () {
          // Browser blocked autoplay for now; wait for interaction/visibility.
        });
      return;
    }

    if (!pageHeaderVideo.paused) {
      hasStarted = true;
      cleanupInteractionListeners();
    }
  };

  const startFromUserInteraction = function () {
    attemptAutoplay();
    if (!pageHeaderVideo.paused) {
      hasStarted = true;
      cleanupInteractionListeners();
    }
  };

  document.addEventListener("click", startFromUserInteraction);
  document.addEventListener("touchstart", startFromUserInteraction);
  document.addEventListener("keydown", startFromUserInteraction);

  document.addEventListener("visibilitychange", function () {
    if (!document.hidden && pageHeaderVideo.paused) {
      attemptAutoplay();
    }
  });

  if (pageHeaderVideo.readyState >= 2) {
    attemptAutoplay();
  } else {
    pageHeaderVideo.addEventListener("loadeddata", attemptAutoplay, { once: true });
    pageHeaderVideo.addEventListener("canplay", attemptAutoplay, { once: true });
  }

  setTimeout(attemptAutoplay, 150);
}; // pageHeaderVideoInit();
pageHeaderVideoInit();

/*  ==========================================================================
  Count Up Stats 
========================================================================== */
document.addEventListener("DOMContentLoaded", () => {
  const statisticsSection = document.querySelector(".module--statistics");
  const statFigures = document.querySelectorAll(".stat__number-figure");
  let counted = false;

  function countUp(element, endValue, duration = 2000) {
    let startValue = 0;
    let startTime = null;

    function updateCounter(currentTime) {
      if (!startTime) startTime = currentTime;
      const elapsedTime = currentTime - startTime;
      const progress = Math.min(elapsedTime / duration, 1);
      const currentValue = Math.floor(progress * (endValue - startValue) + startValue);

      element.textContent = currentValue;

      if (progress < 1) {
        requestAnimationFrame(updateCounter);
      }
    }
    requestAnimationFrame(updateCounter);
  }

  function handleScroll() {
    const sectionTop = statisticsSection.getBoundingClientRect().top;
    const windowHeight = window.innerHeight;

    if (sectionTop < windowHeight && !counted) {
      counted = true;
      statFigures.forEach(figure => {
        const targetValue = parseInt(figure.textContent.replace(/,/g, ""), 10);
        if (!isNaN(targetValue)) {
          countUp(figure, targetValue);
        }
      });
    }
  }

  window.addEventListener("scroll", handleScroll);
  handleScroll(); // Run once in case the section is already in view
});

/*  ==========================================================================
    AJAX - AJAX load more / paging
    ========================================================================== */

const loadmoreBtn = document.querySelector(".paging__loadmore");
const loadmoreContainer = document.querySelector(".loadmore-container");

const loadmoreLoadPosts = function () {
  const button = this;
  const data = {
    action: "loadmore",
    query: php_variables.posts, // that's how we get params from wp_localize_script() function
    page: php_variables.current_page
  };
  let buttonText; // create variable to store button text

  // This AJAX triggers a PHP hook within functions-ajax.php called ajax_loadmore_handler
  $.ajax({
    url: php_variables.ajax_url, // AJAX handler
    data: data,
    type: "POST",
    beforeSend: function (xhr) {
      buttonText = button.textContent; // store current button text
      button.textContent = "Loading..."; // change the button text, to let the user know we are loading more posts
    },
    success: function (data) {
      if (data) {
        button.textContent = buttonText; // set back to previous button text
        loadmoreContainer.innerHTML = loadmoreContainer.innerHTML + data; // insert new posts to the loadmore-container, this should be the row that includes the posts
        php_variables.current_page++;
        // if last page, remove the button..
        if (parseInt(php_variables.current_page) === parseInt(php_variables.max_page)) {
          button.remove();
        }
        // Re-init links to make sure linklines on newly loaded content still work
        linksInit();
        // Re-init lazy load
        lazyLoadInstance.update(); // reinit lazy load after clones
        // Re-init effects
        effectsInit();
      } else {
        button.remove(); // if no data, remove the button as well
      }
    }
  });
}; // loadmoreLoadPosts();

const loadmoreInit = function () {
  if (!loadmoreBtn) {
    return;
  }

  loadmoreBtn.addEventListener("click", loadmoreLoadPosts);
}; // loadmoreInit();
loadmoreInit();

/*  ==========================================================================
    Scroll effects
    ========================================================================== */

const effects = document.querySelectorAll('.effect');

const effectsInit = function () {
	if (!effects) {
		return;
	}

	effects.forEach(function (val) {
		const waypoints = new Waypoint({
			element: val,
			handler: function (direction) {
				if (direction === 'down') {
					val.classList.add('effect--ready');
				}
			},
			offset: '99.5%',
		});
	});
}; // effectsInit();
effectsInit();

/*  ==========================================================================
			Grid Carousel (Currently used on Featured Posts & Featured People)
			========================================================================== */

const gridCarousels = document.querySelectorAll('.row--carousel .owl-carousel');

const gridCarouselInit = function (gridCarousels) {
	if (gridCarousels.length <= 0) {
		return;
	}

	gridCarousels.forEach((elem) => {
		const slides = elem.querySelectorAll('.col');
		if (!slides) {
			return;
		}

		const responsiveArray = carouselResponsiveArray(elem);

		// Optional data attribute settings
		const autoplay = elem.dataset.autoplay ? elem.dataset.autoplay : false;
		const autoplayTimeout = elem.dataset.autoplayTimeout ? elem.dataset.autoplayTimeout : 5000;
		const loop = elem.dataset.loop ? elem.dataset.loop : false;
		const nav = elem.dataset.nav ? elem.dataset.nav : false;
		const dots = elem.dataset.dots ? elem.dataset.dots : false;
		// Default for autoheight is "true", so to turn off you need to set the data-attribute to "disable"
		const autoHeight =
			elem.dataset.autoHeight && elem.dataset.autoHeight === 'disable' ? false : true;

		$(elem).owlCarousel({
			autoplay: autoplay,
			autoplayTimeout: autoplayTimeout,
			loop: loop,
			nav: nav,
			dots: dots,
			items: 1,
			navText: ["<i class='far fa-arrow-left'></i>", "<i class='far fa-arrow-right'></i>"],
			responsive: responsiveArray,
			startPosition: slides.length,
			autoHeight: autoHeight,
			lazyLoad: true
		});

		$(elem).on('resized.owl.carousel', function (event) {
			// Refresh waypoints on resize with slight delay - bit of a hack but stop its breaking waypoint animations
			setTimeout(function () {
				Waypoint.refreshAll();
				lazyLoadInstance.update();
			}, 500);
		});
	});
}; // gridCarouselInit();
setTimeout(function () {
	gridCarouselInit(gridCarousels);
	lazyLoadInstance.update();
}, 500);
/*  ==========================================================================
    Grid Carousel - Create responsive array 
    ========================================================================== */

function carouselResponsiveArray(elem) {
	let responsiveArray = {};
	const slides = elem.querySelectorAll('.col');
	const classes = slides[0].classList;

	classes.forEach((cl, index) => {
		if (cl.indexOf('col-') !== -1) {
			let className = cl;
			let classWidth = 0;
			let numItems = 4;
			className = cl.replace('col-', '');
			// get min width from col class
			const classGridsize = className.split('-')[0];
			// check this is a string not a number, this will remove up cols that dont have a grid size e.g. col-1-2
			if (isNaN(classGridsize)) {
				className = className.replace(classGridsize + '-', '');
				classWidth = gridSizes[classGridsize];
			} else {
				classWidth = 0;
			}
			// split rest of class into sections (this should now be something like '1-4')
			const otherClassParts = className.split('-');
			// divide second number (e.g 4) by first number (e.g 1) to get number of items
			if (otherClassParts[1]) {
				numItems = otherClassParts[1] / otherClassParts[0];
			} else {
				numItems = 1; // if there isn't a second number it must be a single grid
			}
			responsiveArray[classWidth] = {
				items: numItems,
			};
		}
	});

	return responsiveArray;
} // carouselResponsiveArray();

/*  ==========================================================================
	NAVIGATION - Scroll Animation
	========================================================================== */

var siteheader = document.querySelector(".siteheader");
window.onscroll = function () {
  scrollFunction();
};

function scrollFunction() {
  80 < document.body.scrollTop || 80 < document.documentElement.scrollTop
    ? siteheader.classList.add("scroll")
    : siteheader.classList.remove("scroll");
}

/*  ==========================================================================
	NAVIGATION - mobnav
	========================================================================== */

const mobnav = document.querySelector(".mobnav");
const mobnavToggle = document.querySelector(".mobnav-toggle");
const closeBtn = document.querySelector(".closebtn");
const overlay = document.querySelector(".overlay");
const mobnavOpenclass = "mobnavopen";

function openNav() {
  mobnav.style.width = "250px";
}

function closeNav() {
  mobnav.style.width = "0";
}

const mobnavInit = function () {
  // Open mobnav on click the toggle
  mobnavToggle.addEventListener("click", function (e) {
    e.preventDefault();

    if (!body.classList.contains(mobnavOpenclass)) {
      openNav();
      body.classList.add(mobnavOpenclass);
      overlay.classList.add("active");
    } else {
      closeNav();
      body.classList.remove(mobnavOpenclass);
      overlay.classList.remove("active");
    }
  });

  closeBtn.addEventListener("click", function (e) {
    e.preventDefault();
    body.classList.remove(mobnavOpenclass);
    overlay.classList.remove("active");
    closeNav();
  });

  overlay.addEventListener("click", function (e) {
    e.preventDefault();
    body.classList.remove(mobnavOpenclass);
    overlay.classList.remove("active");
    closeNav();
  });
}; // mobnavInit()
mobnavInit();


/*  ==========================================================================
    GENERAL - Footer marquee runtime cloning
    ========================================================================== */

const footerMarqueeInit = function () {
  const marquees = document.querySelectorAll(".sitefooter__marquee__bd");

  if (!marquees.length) {
    return;
  }

  const syncMarquee = function (marqueeBody) {
    const track = marqueeBody.querySelector(".sitefooter__marquee__track");

    if (!track) {
      return;
    }

    const sourceGroup = track.querySelector(".sitefooter__marquee__group:not([data-marquee-clone])");

    if (!sourceGroup) {
      return;
    }

    track.querySelectorAll(".sitefooter__marquee__group[data-marquee-clone='true']").forEach(function (clone) {
      clone.remove();
    });

    const sourceWidth = sourceGroup.getBoundingClientRect().width;
    const containerWidth = marqueeBody.getBoundingClientRect().width;

    if (!sourceWidth || !containerWidth) {
      return;
    }

    const requiredGroups = Math.max(2, Math.ceil(containerWidth / sourceWidth) + 2);

    for (let i = 1; i < requiredGroups; i++) {
      const clone = sourceGroup.cloneNode(true);
      clone.setAttribute("aria-hidden", "true");
      clone.dataset.marqueeClone = "true";
      track.appendChild(clone);
    }

    const baseDuration = Math.max(48, sourceWidth / 20);
    track.style.setProperty("--marquee-shift", sourceWidth + "px");
    track.style.setProperty("--marquee-duration", baseDuration + "s");
  };

  const debounce = function (fn, wait) {
    let timeoutId;

    return function () {
      clearTimeout(timeoutId);
      timeoutId = setTimeout(fn, wait);
    };
  };

  marquees.forEach(function (marqueeBody) {
    syncMarquee(marqueeBody);
  });

  const syncAllMarquees = debounce(function () {
    marquees.forEach(function (marqueeBody) {
      syncMarquee(marqueeBody);
    });
  }, 150);

  window.addEventListener("resize", syncAllMarquees);
};

footerMarqueeInit();
